import { Typography, TextField, FormLabel, FormControl, Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ContentLayout from '../ContentLayout/ContentLayout';

const GET_PROFILES = "/profile";

export const Profile = () => {

const auth = useAuth();
const navigate = useNavigate();

  const [profile, setProfile] = useState({
    name: '',
    email: '',
    mobile: ''
  });

    // Function to format phone number for display
  const formatPhoneNumber = (phoneNumber) => {
        if (phoneNumber === null || phoneNumber === undefined || phoneNumber === '') return '';

        const phoneStr = String(phoneNumber);
        const cleaned = phoneStr.replace(/\D/g, '');

        if (cleaned.length === 10) {
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        return phoneStr;
    };

  const token = localStorage.getItem('token');

  useEffect(() => {
    const requestData = {
      token: token
    };
  
    axios.post(GET_PROFILES, requestData)
      .then((response) => {
        if (response?.status === 200) {
          setProfile({
            name: `${response.data.message.first || ''} ${response.data.message.last || ''}`.trim(),
            email: response.data.message.email || '',
            mobile: response.data.message.mobile || ''
          });

        } else if (response?.status === 400) {
          console.log("Bad Request:", response.data);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, [token]);

  const handleClose = () => {
    auth.logout()
    navigate('/');
  };
// px: 5, py: 5 = margin: 40px
    return (
      <ContentLayout title={"Profile"} url={"/plans"}>
      

      <Typography variant="h6" fontWeight="medium" letterSpacing="0.15px" lineHeight="160%" gutterBottom sx={{ mb: '24px', mt: '24px', marginLeft:'24px' }}>
        Personal Information
      </Typography>

      <Box display="flex" flexDirection="column" gap={3} maxWidth="full" variant='Standard' marginLeft='24px' >
        <TextField
          label="Name"
          fullWidth
          value={profile.name}
          InputProps={{ readOnly: true }}
          variant="standard"
        />
        <TextField
          label="Email"
          fullWidth
          value={profile.email}
          InputProps={{ readOnly: true }}
          variant="standard"
        />
        <FormControl fullWidth>
  <FormLabel>Mobile Number</FormLabel>
  <Typography
    variant="body1"
    sx={{
      mt: 1,
      pb: 0.5,
      borderBottom: "1px solid rgba(0, 0, 0, 0.42)", // matches MUI TextField underline
    }}
  >
    {formatPhoneNumber(profile.mobile) || ""}
  </Typography>
</FormControl>
      </Box>

      <Box
        sx={{
          position: 'fixed',
          right: 70, // Increase this to move the button to the left
          bottom: 50
        }}
      >
        <Button
          variant="text"
          onClick={handleClose}
          sx={{
            color: '#1976d2',
            fontWeight: 'bold',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
          }}
        >
          SIGN OUT
        </Button>
      </Box>

    </ContentLayout>
    )
}